import { Modal, SpinnerOverlay } from "@vesatogo/grass-core"
import { pick } from "lodash-es"
import { useSearchParams } from "react-router-dom"
import TraderSummary from "~/components/TraderSummary"
import { Base_User, useInvoicePreviewQuery } from "~/generated/graphql"
import { downloadInvoice } from "~/pages/d/trade-requests/invoices"
import { calculateFinalAmount } from "~/pages/pavti/lib/calculate-bifurcation-total"

const PreviewInvoice = () => {
  const [params, setParams] = useSearchParams()
  const isOpen = params.get("invoice") ? true : false
  const invoiceId = parseInt(params.get("invoice") || "")

  const [{ data, fetching }] = useInvoicePreviewQuery({
    variables: {
      id: invoiceId,
    },
    pause: !invoiceId,
  })

  const invoice = data?.invoice_by_pk

  const quantityUnit = invoice?.trades?.[0]?.trade_items?.[0]?.quantity_unit
  const rateUnit = invoice?.trades?.[0]?.trade_items?.[0]?.rate_unit

  return (
    <Modal
      bodyClassName="w-[60%]"
      isOpen={isOpen}
      onClose={() => {
        params.delete("invoice")
        setParams(params)
      }}
      secondaryActionButtonProps={{
        text: "Close",
        onClick() {
          params.delete("invoice")
          setParams(params)
        },
      }}
      primaryActionButtonProps={{
        text: "Download Invoice",
        async onClick() {
          downloadInvoice(invoice?.id)()
        },
      }}
      title={`Invoice No : #${invoiceId}`}
    >
      <SpinnerOverlay show={fetching} />
      <TraderSummary
        total_amount={calculateFinalAmount(
          pick(
            invoice?.buyer_bifurcation as any,
            "deducted_amount",
            "buyer_expense_amount",
            "buyer_expense_tax_amount",
            "buyer_tax_amount"
          )
        )}
        total_quantity={invoice?.deducted_quantity}
        tax_amount={invoice?.buyer_bifurcation?.buyer_tax_amount?.val}
        trader={invoice?.buyer?.user?.[0] as Base_User}
        rate_unit={rateUnit}
        quantity_unit={quantityUnit}
        standard_deduction={invoice?.standard_deduction}
        expense_amount={calculateFinalAmount(
          pick(
            invoice?.buyer_bifurcation as any,
            "buyer_expense_amount",
            "buyer_expense_tax_amount"
          )
        )}
        trades={invoice?.trades as any}
      />
    </Modal>
  )
}

export default PreviewInvoice
